import { createTheme } from "@mui/material/styles";
import { colors } from "./colors";

export function createAppTheme(mode = "light") {
  const dark = mode === "dark";

  return createTheme({
    palette: {
      mode,
      primary: {
        main: colors.gold,
        dark: colors.goldHover,
        light: "#d4b892",
        contrastText: colors.black,
      },
      secondary: {
        main: dark ? "#111113" : colors.black,
        contrastText: colors.white,
      },
      error: {
        main: colors.error,
      },
      background: {
        default: dark ? "#0d0d0d" : "#ffffff",
        paper: dark ? "#1b1b1e" : "#ffffff",
      },
      text: {
        primary: dark ? "#f2f2f2" : colors.text,
        secondary: dark ? "rgba(255,255,255,0.68)" : "rgba(0,0,0,0.6)",
      },
      divider: dark ? "rgba(255,255,255,0.12)" : "rgba(0,0,0,0.12)",
    },
    shape: {
      borderRadius: 6,
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            backgroundColor: dark ? "#0d0d0d" : undefined,
            color: dark ? "#f2f2f2" : undefined,
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: dark
            ? { backgroundImage: "none" }
            : {},
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: dark
            ? {
                backgroundColor: "#232326",
              }
            : {},
        },
      },
      MuiDialog: {
        styleOverrides: {
          paper: dark
            ? { backgroundImage: "none", backgroundColor: "#1b1b1e" }
            : {},
        },
      },
      MuiButton: {
        styleOverrides: {
          outlinedSecondary: dark
            ? {
                color: "#f2f2f2",
                borderColor: "rgba(255,255,255,0.45)",
                "&:hover": {
                  borderColor: "rgba(255,255,255,0.7)",
                  backgroundColor: "rgba(255,255,255,0.06)",
                },
              }
            : {},
        },
      },
    },
  });
}

const muiTheme = createAppTheme("light");

export default muiTheme;
